interface ErrorToastProps {
  errorMsg: string;
}

export default function ErrorToast({ errorMsg }: ErrorToastProps) {
  return (
    <div className="absolute top-2 left-2 right-15 flex items-center justify-between z-10">
      <div className="bg-red-600/25 backdrop-blur-sm rounded-2xl py-2.5 px-4 flex-1 shadow-inset-white-10">
        <p className="text-white text-sm font-normal">
          {errorMsg || "An error occurred. Please try again."}
        </p>
      </div>
    </div>
  );
}

